var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "career-detail"
  }, [_c('div', {
    staticClass: "mb-6"
  }, [_c('button', {
    staticClass: "flex items-center gap-2 text-neutral-600 hover:text-primary-500 transition-colors mb-4",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/career');
      }
    }
  }, [_c('span', [_vm._v("←")]), _c('span', [_vm._v("Back to Career List")])]), _c('div', {
    staticClass: "bg-white rounded-lg shadow-sm p-6"
  }, [_c('h2', {
    staticClass: "text-2xl font-bold text-neutral-800 mb-4"
  }, [_vm._v(" " + _vm._s(_vm.careerData.title) + " ")]), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-3 gap-4 mb-4"
  }, [_c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Location")]), _c('p', {
    staticClass: "font-medium text-neutral-700"
  }, [_vm._v(" " + _vm._s(_vm.careerData.location) + " ")])]), _c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Work Type")]), _c('p', {
    staticClass: "font-medium"
  }, [_c('span', {
    staticClass: "px-2 py-1 rounded text-xs font-medium",
    class: _vm.workTypeClass(_vm.careerData.work_type)
  }, [_vm._v(" " + _vm._s(_vm.careerData.work_type) + " ")])])]), _c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Period")]), _c('p', {
    staticClass: "font-medium text-neutral-700"
  }, [_vm._v(" " + _vm._s(_vm.formatDate(_vm.careerData.start_date)) + " - " + _vm._s(_vm.formatDate(_vm.careerData.end_date)) + " ")])])]), _c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500 mb-2"
  }, [_vm._v("Description")]), _c('div', {
    staticClass: "text-neutral-700",
    domProps: {
      "innerHTML": _vm._s(_vm.careerData.description)
    }
  })])])]), _c('div', {
    staticClass: "bg-white rounded-lg shadow-sm p-6"
  }, [_c('div', {
    staticClass: "flex gap-5 justify-between items-end mb-6 mdmax:flex-col"
  }, [_c('h3', {
    staticClass: "text-xl font-bold text-neutral-800"
  }, [_vm._v("Job Applications")]), _c('div', {
    staticClass: "flex gap-3 mdmax:w-full"
  }, [_c('div', {
    staticClass: "w-48 mdmax:w-full"
  }, [_c('CustomSelect', {
    attrs: {
      "options": _vm.statusOptions,
      "default": _vm.statusFilter,
      "placeholder": "All Status"
    },
    on: {
      "change": _vm.onFilterChange
    },
    model: {
      value: _vm.statusFilter,
      callback: function ($$v) {
        _vm.statusFilter = $$v;
      },
      expression: "statusFilter"
    }
  })], 1)])]), _c('div', {
    staticClass: "overflow-x-auto"
  }, [_c('table', {
    staticClass: "w-full text-left border-collapse"
  }, [_vm._m(0), _c('tbody', {
    staticClass: "text-neutral-700 text-sm"
  }, [_vm._l(_vm.items, function (submission, index) {
    return _c('tr', {
      key: submission.id,
      staticClass: "border-b border-neutral-100 hover:bg-neutral-50 transition-colors"
    }, [_c('td', {
      staticClass: "p-4"
    }, [_vm._v(_vm._s((_vm.page - 1) * _vm.limit + index + 1))]), _c('td', {
      staticClass: "p-4 font-medium"
    }, [_vm._v(_vm._s(submission.name))]), _c('td', {
      staticClass: "p-4"
    }, [_vm._v(_vm._s(submission.email))]), _c('td', {
      staticClass: "p-4"
    }, [_vm._v(_vm._s(submission.phone_number))]), _c('td', {
      staticClass: "p-4"
    }, [_c('span', {
      staticClass: "px-2 py-1 rounded text-xs font-medium",
      class: _vm.statusClass(submission.status)
    }, [_vm._v(" " + _vm._s(submission.status) + " ")])]), _c('td', {
      staticClass: "p-4"
    }, [_vm._v(_vm._s(_vm.formatDate(submission.created_at)))]), _c('td', {
      staticClass: "p-4"
    }, [_c('div', {
      staticClass: "flex items-center gap-2"
    }, [_c('button', {
      staticClass: "text-neutral-500 hover:text-primary-500 transition-colors",
      attrs: {
        "title": "View Details"
      },
      on: {
        "click": function ($event) {
          return _vm.viewSubmission(submission);
        }
      }
    }, [_c('Eye', {
      attrs: {
        "width": "18",
        "height": "18"
      }
    })], 1), _c('button', {
      staticClass: "text-neutral-500 hover:text-blue-500 transition-colors",
      attrs: {
        "title": "Update Status"
      },
      on: {
        "click": function ($event) {
          return _vm.openStatusModal(submission);
        }
      }
    }, [_c('Edit', {
      attrs: {
        "width": "18",
        "height": "18"
      }
    })], 1), _c('button', {
      staticClass: "text-neutral-500 hover:text-red-500 transition-colors",
      attrs: {
        "title": "Delete"
      },
      on: {
        "click": function ($event) {
          return _vm.onDelete(submission);
        }
      }
    }, [_c('Trash', {
      attrs: {
        "width": "18",
        "height": "18"
      }
    })], 1)])])]);
  }), !_vm.items || _vm.items.length === 0 ? _c('tr', [_c('td', {
    staticClass: "p-4 text-center text-neutral-500",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v(" No applications found! ")])]) : _vm._e()], 2)])]), !_vm.isMobile && _vm.items.length > 0 ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-4 text-sm"
  }, [_vm._v(" Showing " + _vm._s((_vm.page - 1) * _vm.limit + 1) + " - " + _vm._s(Math.min(_vm.page * _vm.limit, _vm.meta.total_count)) + " of " + _vm._s(_vm.meta.total_count) + " ")]) : _vm._e(), _vm.items.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-end items-center"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.page,
      "totalCount": _vm.meta.total_count,
      "pageSize": _vm.limit
    },
    on: {
      "onPageChange": _vm.changePage
    }
  })], 1) : _vm._e()]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.detailModalVisible,
      "width": "700px"
    },
    on: {
      "close": _vm.closeDetailModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-xl font-bold text-neutral-800 mb-4"
  }, [_vm._v(" Application Details ")]), _vm.selectedSubmission ? _c('div', {
    staticClass: "space-y-4"
  }, [_c('div', {
    staticClass: "grid grid-cols-2 gap-4"
  }, [_c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Name")]), _c('p', {
    staticClass: "font-medium text-neutral-700"
  }, [_vm._v(" " + _vm._s(_vm.selectedSubmission.name) + " ")])]), _c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Email")]), _c('p', {
    staticClass: "font-medium text-neutral-700"
  }, [_vm._v(" " + _vm._s(_vm.selectedSubmission.email) + " ")])]), _c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Phone Number")]), _c('p', {
    staticClass: "font-medium text-neutral-700"
  }, [_vm._v(" " + _vm._s(_vm.selectedSubmission.phone_number) + " ")])]), _c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Status")]), _c('span', {
    staticClass: "px-2 py-1 rounded text-xs font-medium inline-block",
    class: _vm.statusClass(_vm.selectedSubmission.status)
  }, [_vm._v(" " + _vm._s(_vm.selectedSubmission.status) + " ")])])]), _c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500 mb-1"
  }, [_vm._v("CV")]), _c('a', {
    staticClass: "text-primary-500 hover:text-primary-600 underline",
    attrs: {
      "href": _vm.selectedSubmission.cv_url,
      "target": "_blank"
    }
  }, [_vm._v(" View CV ")])]), _vm.selectedSubmission.portfolio_url ? _c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500 mb-1"
  }, [_vm._v("Portfolio")]), _c('a', {
    staticClass: "text-primary-500 hover:text-primary-600 underline",
    attrs: {
      "href": _vm.selectedSubmission.portfolio_url,
      "target": "_blank"
    }
  }, [_vm._v(" View Portfolio ")])]) : _vm._e(), _c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500 mb-1"
  }, [_vm._v("Reason to Hire")]), _c('p', {
    staticClass: "text-neutral-700"
  }, [_vm._v(" " + _vm._s(_vm.selectedSubmission.reason_to_hire) + " ")])]), _c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500 mb-1"
  }, [_vm._v("Candidate Description")]), _c('p', {
    staticClass: "text-neutral-700"
  }, [_vm._v(" " + _vm._s(_vm.selectedSubmission.candidate_description) + " ")])]), _c('div', {
    staticClass: "grid grid-cols-2 gap-4"
  }, [_c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Applied Date")]), _c('p', {
    staticClass: "font-medium text-neutral-700"
  }, [_vm._v(" " + _vm._s(_vm.formatDate(_vm.selectedSubmission.created_at)) + " ")])]), _c('div', [_c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v("Last Updated")]), _c('p', {
    staticClass: "font-medium text-neutral-700"
  }, [_vm._v(" " + _vm._s(_vm.formatDate(_vm.selectedSubmission.updated_at)) + " ")])])])]) : _vm._e()])]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.statusModalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeStatusModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-4"
  }, [_vm._v(" Update Application Status ")]), _vm.selectedSubmission ? _c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "text-sm text-neutral-600 mb-1"
  }, [_vm._v(" Candidate: "), _c('strong', [_vm._v(_vm._s(_vm.selectedSubmission.name))])]), _c('p', {
    staticClass: "text-sm text-neutral-600 mb-4"
  }, [_vm._v(" Current Status: "), _c('span', {
    staticClass: "px-2 py-1 rounded text-xs font-medium",
    class: _vm.statusClass(_vm.selectedSubmission.status)
  }, [_vm._v(" " + _vm._s(_vm.selectedSubmission.status) + " ")])]), _c('label', {
    staticClass: "block text-sm font-semibold mb-2"
  }, [_vm._v("New Status")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newStatus,
      expression: "newStatus"
    }],
    staticClass: "w-full border border-neutral-300 rounded px-3 py-2 focus:ring focus:ring-blue-400 focus:border-blue-400",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.newStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Status")]), _vm._l(_vm.statusOptions, function (status) {
    return _c('option', {
      key: status,
      domProps: {
        "value": status
      }
    }, [_vm._v(" " + _vm._s(status) + " ")]);
  })], 2)]) : _vm._e(), _c('div', {
    staticClass: "flex justify-end gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_vm._v(" Cancel ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-blue-500 text-white hover:bg-blue-600 font-medium",
    attrs: {
      "disabled": !_vm.newStatus
    },
    on: {
      "click": _vm.confirmUpdateStatus
    }
  }, [_vm._v(" Update Status ")])])])]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.deleteModalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeDeleteModal
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-2"
  }, [_vm._v(" Delete Application ")]), _c('p', {
    staticClass: "text-neutral-600 mb-6"
  }, [_vm._v(" Are you sure you want to delete the application from "), _c('strong', [_vm._v(_vm._s(_vm.submissionToDelete ? _vm.submissionToDelete.name : ""))]), _vm._v("? ")]), _c('div', {
    staticClass: "flex justify-center gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeDeleteModal
    }
  }, [_vm._v(" Cancel ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium",
    on: {
      "click": _vm.confirmDelete
    }
  }, [_vm._v(" Delete ")])])])])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', {
    staticClass: "bg-neutral-50 text-neutral-500 text-sm font-semibold border-b border-neutral-200"
  }, [_c('th', {
    staticClass: "p-4"
  }, [_vm._v("No")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Name")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Email")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Phone")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Status")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Applied Date")]), _c('th', {
    staticClass: "p-4"
  }, [_vm._v("Action")])])]);

}]

export { render, staticRenderFns }